
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M135.333 61.536a122.232 122.232 0 00-25.083-21l23.333-23.304a5.833 5.833 0 10-8.248-8.249l-.105.105a4.3 4.3 0 01-1.01 1.698L10.47 124.536c-.046.04-.104.052-.15.099a5.833 5.833 0 009.513 6.347l24.185-24.185a65.683 65.683 0 0025.142 5.477h1.75c24.827 0 49.52-17.407 64.464-33.833a12.664 12.664 0 00-.04-16.905zM95.16 77.408a26.723 26.723 0 01-17.5 17.664 25.083 25.083 0 01-18.083-1.109 1.476 1.476 0 01-.397-2.374l32.433-32.427a1.47 1.47 0 012.375.39 25.083 25.083 0 011.172 17.856zm-50.74.759a1.423 1.423 0 00.357-1.4A25.17 25.17 0 0143.75 70 26.25 26.25 0 0170 43.75a24.943 24.943 0 016.767 1.01 1.423 1.423 0 001.4-.362l11.322-11.329a1.482 1.482 0 00-.583-2.456A60.742 60.742 0 0070 27.708C44.917 27.37 19.833 44.917 4.743 61.536a12.542 12.542 0 00-.041 16.916 123.72 123.72 0 0020.055 17.675 1.493 1.493 0 001.901-.169z"}})])
          )
        }
      }
    